<template>
    <div class="charts">
      test
    </div>
</template>
<script>
export default {
  name: 'CommerciaVueDashboard',
  components: {
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style scoped>
  @import '@/assets/styles/sections.css';
  @import '@/assets/styles/inputs.css';
  @import '@/assets/styles/dashboard.css';
</style>
